const getModuleState = (state) => state.app;

export const getTokenRecaptcha = (state) => getModuleState(state).tokenRecaptcha;